import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

    constructor(private auth: AuthService) { }
    userData: any = {};

    ngOnInit(): void {
        this.userData = this.auth.userData;
    }

}
